import { type PropsWithChildren, useState } from 'react';
import { NavbarMenuBurgerContext } from './context';

export function NavbarMenuBurgerProvider({ children }: PropsWithChildren) {
  const [isOpen, setIsOpen] = useState(false);

  return <NavbarMenuBurgerContext.Provider value={{ isOpen, setIsOpen }}>{children}</NavbarMenuBurgerContext.Provider>;
}
